import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['all', 'item', 'submit'];

  connect() {
    this.#refreshAll();
    this.#refreshSubmit();
  }

  // action="input->checkboxes#toggleAll"
  toggleAll({ target }) {
    for (const item of this.itemTargets) {
      item.checked = target.checked;
    }
    this.#refreshSubmit();
  }

  // action="input->checkboxes#toggleItem"
  toggleItem() {
    this.#refreshAll();
    this.#refreshSubmit();
  }

  // item は checked の既定値をサーバ側で決める画面があるため、初期表示でも突き合わせる。
  // item が 0 件のとき every は true を返すので、件数で切る
  #refreshAll() {
    if (!this.hasAllTarget) return;

    this.allTarget.checked =
      this.itemTargets.length > 0 &&
      this.itemTargets.every((item) => item.checked);
  }

  // submit target は任意。選択した対象に対して操作するボタンを持つ画面だけが使う
  // 一覧の上下など複数置かれることがあるので、すべてに反映する
  #refreshSubmit() {
    const disabled = !this.itemTargets.some((item) => item.checked);

    for (const submit of this.submitTargets) {
      submit.disabled = disabled;
    }
  }
}
